import { GET_COINDATA } from "../actions/types";
const initialState = [];
export default function coinDataReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_COINDATA:
      return {
        ...state,
        coinData: payload,
      };
    default:
      return {
        ...state,
        coinData: [],
      };
  }
}
